<template>
<ValidationObserver ref="formValidation">
<div>
<div class="row">
            <div class="col-md-4">
              <h5>Configuración</h5>
              <div class="row">
                <div class="col-md-6">
                  En millar <select class="form-control" style="width:80%" v-model="objexercise.SIGNO_MILLAR">
                      <option value="0">.</option>
                      <option value="1">,</option>
                      <option value="2">Espacio</option>
                    </select>
                  En decimal <select class="form-control" style="width:80%" v-model="objexercise.SIGNO_DECIMAL">
                      <option value="1">.</option>
                      <option value="0">,</option>
                    </select>
                    <br>
                </div>
                <div class="col-md-6">
                  Multiplicación <select class="form-control" style="width:80%" v-model="objexercise.SIGNO_MULTI">
                      <option value="0">*</option>
                      <option value="1">x</option>
                      <option value="2">·</option>
                      <option value="3">de</option>
                    </select>
                  División <select class="form-control" style="width:80%" v-model="objexercise.SIGNO_DIVI">
                      <option value="0">/</option>
                      <option value="1">:</option>
                      <option value="2">÷</option>
                    </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-11">
                  Orden de elementos
                    <select class="form-control mb-2" v-model="objexercise.ORDEN_ELEMENTOS">
                    <option value="0">Aleatorio</option>
                    <option value="1">Orden de autor</option>
                    <option value="2">Orden inverso</option>
                  </select>
                  Número de elementos
                  <select class="form-control" v-model="objexercise.NUM_ELEMENTOS">
                    <option v-for="i in objexercise.MAX_NUM_ELEMENTOS" :key="i" :value="i">
                        {{ i }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <h5>Parámetros de evaluación</h5>
              Evaluación positiva del % de operaciones superadas
              <ValidationProvider rules="required|between:1,100" v-slot="{ errors }">
                <b-form-input v-model="objexercise.EVALUACION"
                  type="number" min="0" max="100" />
                <span class="validation-error">{{ errors[0] }}</span>
              </ValidationProvider>
              <br /><br />
              <div class="mt-2">
                <div>
                  Tiempo de respuesta por operación
                  <ValidationProvider rules="required|between:1,600" v-slot="{ errors }">
                  <b-form-input v-model="objexercise.TIEMPO_OPERACION" class="mb-2"
                    type="number" min="0" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div>
                  Tiempo de prórroga de operación
                  <ValidationProvider rules="required|between:1,600" v-slot="{ errors }">
                    <b-form-input v-model="objexercise.TIEMPO_PRORROGA"
                      type="number" min="0" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="col-md-4">
               <h5>Parámetros por operación</h5>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="objexercise.REFUERZO_ACIERTO"
                id="refuerzo_acierto">
                <label class="custom-control-label" for="refuerzo_acierto">
                  Activar refuerzo ante acierto</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="objexercise.TRATAMIENTO_ERROR"
                id="TRATAMIENTO_ERROR">
                <label class="custom-control-label" for="TRATAMIENTO_ERROR">
                  Tratamiento de Error</label>
              </div>
              <div class="custom-control custom-checkbox mb-2">
                <input type="checkbox" class="custom-control-input"
                v-model="objexercise.AUTOPLAY_CONSIGNA_ORAL"
                id="AUTOPLAY_CONSIGNA_ORAL">
                <label class="custom-control-label" for="AUTOPLAY_CONSIGNA_ORAL">
                  Audio de la consigna automático</label>
              </div>
              <br/><br />
              <div class="mt-2">
                Tipo Tratamiento <select class="form-control mb-2"
                v-model="objexercise.TIPO_TRATAMIENTO">
                    <option value="0">Último intento</option>
                    <option value="1">Penúltimo intento</option>
                  </select>
                  <div>
                    N° máximo de intentos en ejercicio
                    <ValidationProvider rules="required|between:1,5" v-slot="{ errors }">
                      <b-form-input v-model="objexercise.NUM_INTENTOS"
                        type="number" min="0" />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
              </div>
            </div>
      </div>
    <br>
    <hr>
</div>
</ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, between } from 'vee-validate/dist/rules';
import * as EngineTypes from '../motores/EngineTypes';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('between', {
  ...between,
  message: 'Entre {min} y {max}.',
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      submitted: false,
      // Mapear con los campos de la tabla EJERCICIOS
      objexercise: {
        ID: null,
        CONSIGNAS_ESCRITAS_ID: null,
        CONSIGNAS_ORALES_ID: null,
        MOTORES_ID: null,
        TEXTOS_ID: null,
        SIGNO_MULTI: this.getDefault_SIGNO_MULTI(),
        SIGNO_DIVI: this.getDefault_SIGNO_DIVI(),
        SIGNO_MILLAR: 2, // Espacio
        SIGNO_DECIMAL: 0, // Coma ,
        TIEMPO_OPERACION: this.getDefault_TIEMPO_OPERACION(),
        TIEMPO_PRORROGA: this.getDefault_TIEMPO_PRORROGA(),
        REFUERZO_ACIERTO: false,
        TRATAMIENTO_ERROR: true,
        TIPO_TRATAMIENTO: this.getDefault_TIPO_TRATAMIENTOS(),
        NUM_INTENTOS: this.getDefault_NUM_INTENTOS(),
        ORDEN_ELEMENTOS: this.getDefault_ORDEN_ELEMENTOS(),
        EVALUACION: 100,
        NUM_ELEMENTOS: 1, // Puede ser el número de operaciones dentro el motor, o inferior.
        MAX_NUM_ELEMENTOS: 1,
        AUTOPLAY_CONSIGNA_ORAL: this.getDefault_AUTOPLAY_CONSIGNA_ORAL(),
      },
    };
  },
  props: {
    exercise: Object,
    engine: Number,
  },
  methods: {
    active() {
      return null;
    },
    getDefault_AUTOPLAY_CONSIGNA_ORAL() {
      switch (this.engine) {
        case EngineTypes.default.NUM_FRACCIONES:
        case EngineTypes.default.NUM_NATURALES:
        case EngineTypes.default.NUM_DECIMALES:
          return true;
        default: // Default for most of them
          return false;
      }
    },
    getDefault_ORDEN_ELEMENTOS() {
      switch (this.engine) {
        case EngineTypes.default.SER_ENTEROS:
        case EngineTypes.default.SER_DECIMALES:
        case EngineTypes.default.SER_FRACCIONES:
        case EngineTypes.default.SER_ORDINALES:
        case EngineTypes.default.NUM_ENTEROS:
        case EngineTypes.default.PRO_MULTIPLES:
          return 1;
        default: // Default for most of them
          return 0; // Aleatorio
      }
    },
    getDefault_NUM_INTENTOS() {
      switch (this.engine) {
        case EngineTypes.default.EQUIVALENCIAS:
          return 2;
        case EngineTypes.default.PRO_MULTIPLES:
          return 2;
        case EngineTypes.default.NUM_ENTEROS:
          return 2;
        default: // Default for most of them
          return 3;
      }
    },
    getDefault_TIPO_TRATAMIENTOS() {
      switch (this.engine) {
        case EngineTypes.default.FICHACONTENIDO:
        case EngineTypes.default.ALG_SUMRESTA:
        case EngineTypes.default.ALG_MULTI:
        case EngineTypes.default.ALG_SUMTRES:
        case EngineTypes.default.ALG_DIVI:
          return 1;
        default: // Default for most of them
          return 0; // Último intento
      }
    },
    getDefault_TIEMPO_OPERACION() {
      switch (this.engine) {
        case EngineTypes.default.NUM_NATURALES:
          return 8;
        case EngineTypes.default.NUM_ORDINALES:
          return 8;
        case EngineTypes.default.NUM_FRACCIONES:
          return 8;
        case EngineTypes.default.NUM_ROMANOS:
          return 8;
        case EngineTypes.default.NUM_DECIMALES:
          return 8;
        case EngineTypes.default.NUM_POTENCIAS:
          return 10;
        case EngineTypes.default.NUM_PORCENTAJES:
          return 8;
        case EngineTypes.default.NUM_ENTEROS:
          return 8;
        case EngineTypes.default.NUM_MIXTOS:
          return 8;
        case EngineTypes.default.SER_ENTEROS:
          return 15;
        case EngineTypes.default.SER_DECIMALES:
          return 15;
        case EngineTypes.default.SER_FRACCIONES:
          return 15;
        case EngineTypes.default.SER_ORDINALES:
          return 10;
        case EngineTypes.default.HECHOSARIT:
          return 5;
        case EngineTypes.default.OPERACIONES:
          return 15;
        case EngineTypes.default.EQUIVALENCIAS:
          return 10;
        case EngineTypes.default.ALG_SUMRESTA:
          return 30;
        case EngineTypes.default.ALG_MULTI:
          return 30;
        case EngineTypes.default.ALG_SUMTRES:
          return 30;
        case EngineTypes.default.ALG_DIVI:
          return 30;
        case EngineTypes.default.PRO_SIMPLES:
          return 20;
        case EngineTypes.default.PRO_FORMULA:
          return 20;
        case EngineTypes.default.PRO_MULTIPLES:
          return 30;
        case EngineTypes.default.FICHACONTENIDO:
          return 20;
        case EngineTypes.default.TIEMPO:
          return 30;
        case EngineTypes.default.TRATINFORMACION:
          return 15;
        case EngineTypes.default.GEOPLANO:
          return 20;
        case EngineTypes.default.MONEDAS:
          return 15;
        case EngineTypes.default.SEXA_SUMRESTA:
          return 60;
        case EngineTypes.default.SEXA_MULTDIVI:
          return 60;
        case EngineTypes.default.ECU_EQUIVALENCIAS:
          return 80;
        case EngineTypes.default.SEXA_CONVER:
          return 60;
        case EngineTypes.default.ECU_RESOLUCION:
          return 60;
        default: // 'Motor de Interacción';
          return 30;
      }
    },
    getDefault_TIEMPO_PRORROGA() {
      switch (this.engine) {
        case EngineTypes.default.NUM_NATURALES:
          return 16;
        case EngineTypes.default.NUM_ORDINALES:
          return 16;
        case EngineTypes.default.NUM_FRACCIONES:
          return 16;
        case EngineTypes.default.NUM_ROMANOS:
          return 16;
        case EngineTypes.default.NUM_DECIMALES:
          return 16;
        case EngineTypes.default.NUM_POTENCIAS:
          return 20;
        case EngineTypes.default.NUM_PORCENTAJES:
          return 16;
        case EngineTypes.default.NUM_ENTEROS:
          return 16;
        case EngineTypes.default.NUM_MIXTOS:
          return 16;
        case EngineTypes.default.SER_ENTEROS:
          return 30;
        case EngineTypes.default.SER_DECIMALES:
          return 30;
        case EngineTypes.default.SER_FRACCIONES:
          return 30;
        case EngineTypes.default.SER_ORDINALES:
          return 20;
        case EngineTypes.default.HECHOSARIT:
          return 10;
        case EngineTypes.default.OPERACIONES:
          return 30;
        case EngineTypes.default.EQUIVALENCIAS:
          return 20;
        case EngineTypes.default.ALG_SUMRESTA:
          return 60;
        case EngineTypes.default.ALG_MULTI:
          return 60;
        case EngineTypes.default.ALG_SUMTRES:
          return 60;
        case EngineTypes.default.ALG_DIVI:
          return 60;
        case EngineTypes.default.PRO_SIMPLES:
          return 40;
        case EngineTypes.default.PRO_FORMULA:
          return 40;
        case EngineTypes.default.PRO_MULTIPLES:
          return 60;
        case EngineTypes.default.FICHACONTENIDO:
          return 40;
        case EngineTypes.default.TIEMPO:
          return 60;
        case EngineTypes.default.TRATINFORMACION:
          return 30;
        case EngineTypes.default.GEOPLANO:
          return 40;
        case EngineTypes.default.MONEDAS:
          return 30;
        case EngineTypes.default.SEXA_SUMRESTA:
          return 120;
        case EngineTypes.default.SEXA_MULTDIVI:
          return 120;
        case EngineTypes.default.ECU_EQUIVALENCIAS:
          return 160;
        case EngineTypes.default.SEXA_CONVER:
          return 120;
        case EngineTypes.default.ECU_RESOLUCION:
          return 120;
        default: // 'Motor de Interacción';
          return 15;
      }
    },
    getDefault_SIGNO_MULTI() {
      switch (this.engine) {
        case EngineTypes.default.HECHOSARIT:
          return 1;
        case EngineTypes.default.ECU_EQUIVALENCIAS:
        case EngineTypes.default.ECU_RESOLUCION:
        case EngineTypes.default.OPERACIONES:
          return 2;
        case EngineTypes.default.EQUIVALENCIAS:
          return 1;
        case EngineTypes.default.ALG_MULTI:
        case EngineTypes.default.SEXA_MULTDIVI:
          return 1;
        default: // 'Motor de Interacción';
          return 1;
      }
    },
    getDefault_SIGNO_DIVI() {
      switch (this.engine) {
        case EngineTypes.default.HECHOSARIT:
          return 1;
        case EngineTypes.default.ECU_EQUIVALENCIAS:
        case EngineTypes.default.ECU_RESOLUCION:
        case EngineTypes.default.OPERACIONES:
          return 1;
        case EngineTypes.default.EQUIVALENCIAS:
          return 1;
        case EngineTypes.default.ALG_DIVI:
        case EngineTypes.default.SEXA_MULTDIVI:
          return 1;
        default: // 'Motor de Interacción';
          return 1;
      }
    },
  },
  mounted() {
    if (this.exercise !== null) {
      this.objexercise = {
        ID: this.exercise.ID,
        CONSIGNAS_ESCRITAS_ID: this.exercise.CONSIGNAS_ESCRITAS_ID,
        CONSIGNAS_ORALES_ID: this.exercise.CONSIGNAS_ORALES_ID,
        MOTORES_ID: this.exercise.MOTORES_ID,
        TEXTOS_ID: this.exercise.TEXTOS_ID,
        SIGNO_MULTI: this.exercise.SIGNO_MULTI,
        SIGNO_DIVI: this.exercise.SIGNO_DIVI,
        SIGNO_MILLAR: this.exercise.SIGNO_MILLAR,
        SIGNO_DECIMAL: this.exercise.SIGNO_DECIMAL,
        TIEMPO_OPERACION: this.exercise.TIEMPO_OPERACION,
        TIEMPO_PRORROGA: this.exercise.TIEMPO_PRORROGA,
        REFUERZO_ACIERTO: this.exercise.REFUERZO_ACIERTO,
        TRATAMIENTO_ERROR: this.exercise.TRATAMIENTO_ERROR,
        TIPO_TRATAMIENTO: this.exercise.TIPO_TRATAMIENTO,
        NUM_INTENTOS: this.exercise.NUM_INTENTOS,
        NUM_ELEMENTOS: this.exercise.NUM_ELEMENTOS,
        MAX_NUM_ELEMENTOS: this.exercise.NUM_ELEMENTOS,
        ORDEN_ELEMENTOS: this.exercise.ORDEN_ELEMENTOS,
        AUTOPLAY_CONSIGNA_ORAL: this.exercise.AUTOPLAY_CONSIGNA_ORAL,
        EVALUACION: this.exercise.EVALUACION,
      };
    }
  },
};
</script>
